import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./notifications.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { getFocusTrap } from '~/modules/helpers/focusTrap';
import { notificationsStore, selectNotifications } from '~/modules/stores/notificationStore';
import { throwDevelopmentOrLog } from '~/modules/utilities/cross_env_utils';
class Notifications extends LightningElement {
  constructor(...args) {
    super(...args);
    this.notifications = [];
  }
  // @ts-expect-error * Automated Type Error Fix
  notificationsConnected(storeNotifications) {
    // @ts-expect-error * Automated Type Error Fix
    this.notifications = storeNotifications.sort((a, b) => b.id - a.id).slice(0, 3);
  }
  renderedCallback() {
    const container = this.getNotificationsContainerRef;
    if (!container) {
      return;
    }
    this.focusTrap = getFocusTrap(container);
    this.focusTrap?.focusFirstElement();
  }
  get hasNotifications() {
    return this.notifications.length !== 0;
  }
  get getNotificationsContainerRef() {
    // @ts-expect-error * Automated Type Error Fix
    return this.template.querySelector('.notifications-container');
  }
  handleCloseNotification(event) {
    const notificationKey = event?.detail?.iteratorKey;
    if (!notificationKey) {
      throwDevelopmentOrLog(new Error("Attempted to close notification, but it was missing an 'iteratorKey' event detail."));
      return;
    }
    const filteredNotification = this.filterByIteratorKey(notificationKey);
    notificationsStore.removeNotification(notificationKey);
    filteredNotification?.previousFocusedElement?.focus();
  }

  // @ts-expect-error * Automated Type Error Fix
  filterByIteratorKey(notificationKey) {
    return this.notifications.find(notification => notification.iteratorKey === notificationKey);
  }

  // @ts-expect-error * Automated Type Error Fix
  handleInputKey(event) {
    if (event.key === 'Tab') {
      if (event.shiftKey) {
        this.handlePrevFocus(event);
      } else {
        this.handleNextFocus(event);
      }
    }
  }

  // @ts-expect-error * Automated Type Error Fix
  handleNextFocus(event) {
    const {
      focusNext
    } = this.focusTrap;
    const {
      shouldPreventDefault
    } = focusNext();
    if (shouldPreventDefault) {
      event.preventDefault();
    }
  }

  // @ts-expect-error * Automated Type Error Fix
  handlePrevFocus(event) {
    const {
      focusPrevious
    } = this.focusTrap;
    const {
      shouldPreventDefault
    } = focusPrevious();
    if (shouldPreventDefault) {
      event.preventDefault();
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Notifications, {
  wire: {
    notificationsConnected: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: notificationsStore,
          selector: selectNotifications
        };
      }
    }
  },
  fields: ["notifications"]
});
const __lwc_component_class_internal = _registerComponent(Notifications, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;